import React from 'react';
import AddressSearch from './AddressSearch.jsx';
import { DesktopAndTablet, Mobile } from '../../components/Utils/MediaComponents/MediaComponents';

export class SearchHeader extends React.Component {
  render() {
    return (
      <div className="grid-item one-whole indexpage-search-header">
        <div className="buildings-with-listings-background" />
        <div className="grid one-whole img-overlay">
          <div className="grid-item one-whole">
            <div className="grid-flex">
              <DesktopAndTablet
                render={() => (
                  <Headline text="Wir kennen alle Preise." containerStyles="margin-bottom-m margin-top-xxl" />
                )}
              />
              <Mobile render={() => <Headline text="Wir kennen alle Preise." containerStyles="margin-top-l" />} />
              <SubHeadline text="Lernen Sie Ihren kennen." />
              <DesktopAndTablet
                render={() => (
                  <div className="one-whole address-search-wrapper">
                    <div className="grid-item one-whole">
                      <AddressSearch />
                    </div>
                  </div>
                )}
              />
              <Mobile
                render={() => (
                  <div className="address-search-wrapper palm-one-whole">
                    <AddressSearch />
                  </div>
                )}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const Headline = (props) => (
  <div className={`grid-item one-whole ${props.containerStyles}`}>
    <p className="headline">{props.text}</p>
  </div>
);

const SubHeadline = (props) => (
  <div className="grid-item one-whole">
    <p className="sub-headline">{props.text}</p>
  </div>
);

export default SearchHeader;
